import React from "react";

import {cn} from "@isudio/utils";

import {Button, Tooltip, TooltipContent, TooltipTrigger} from "../";

export interface HeaderElement {
  name: string;
  type: "image" | "button" | "span";
  position: "left" | "right";
  icon?: string;
  label?: string;
  tooltip?: string;
  style?: string;
  onClick?: () => void;
  disabled?: boolean;
  hidden?: boolean;
}

interface ToolbarProps {
  name?: string;
  className?: string;
  height?: string;
  elements: HeaderElement[];
  leftToolbarGap?: string;
  rightToolbarGap?: string;
  size?: string;
}

export const ToolbarTop: React.FC<ToolbarProps> = ({
                                                  name,
                                                  className,
                                                  elements,
                                                  leftToolbarGap = "gap-4",
                                                  rightToolbarGap = "gap-4",
                                                  size = "text-2xl",
                                                }) => {
  const elementsLeft: HeaderElement[] = elements.filter(el => el.position === "left");
  const elementsRight: HeaderElement[] = elements.filter(el => el.position === "right");

  const getElement = ((el: HeaderElement, index: number) => {
    switch (el.type) {
      case "button":
        const buttonEl = (
          <Button
            key={index}
            variant="vanilla"
            tabIndex={-1}
            disabled={el?.disabled || false}
            className={cn(`${name}__${el.type}`, `${name}__${el.type}-${el.name} ${size}`, `${el?.style}`, 'cursor-pointer')}
            onClick={el?.onClick}
          >
            <i
              className={`fa-duotone fa-light ${el.icon}`}/>
          </Button>
        );

        return (
          (el?.tooltip && el?.tooltip.length > 0) ? (
            <Tooltip delayDuration={0}>
              <TooltipTrigger
                asChild
                onFocus={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}>
                {buttonEl}
              </TooltipTrigger>
              <TooltipContent side={"bottom"}>
                <p>{el?.tooltip}</p>
              </TooltipContent>
            </Tooltip>
          ) : (
            buttonEl
          )
        );

      case "span":
        return (
          <span
            key={index}
            tabIndex={-1}
            className={cn(`${name}__${el.type}`, `${name}__${el.type}-${el.name}`, `${el?.style}`)}
          >
            {el?.label}
          </span>
        );

      case "image":
        return (
          <img
            src={el?.icon ? el?.icon : ""}
            alt=""
            className={cn(`${name}__${el.type}`, `${name}__${el.type}-${el.name}`, `${el?.style}`)}
            onClick={el?.onClick}
          />
        );
    }
  });

  return (
    <div
      className={cn(`toolbar ${name} h-fit mb-0 py-2 flex justify-between items-center bg-linear-to-b from-gray-darker to-gray-medium`, className)}
    >
      <div
        className={cn("flex items-center pl-4", `${leftToolbarGap}`, `${name}__left`)}>
        {elementsLeft.filter(el => !el.hidden).map((el, index) => (
          getElement(el, index)
        ))}
      </div>
      <div
        className={cn("flex items-center pr-4", `${rightToolbarGap}`, `${name}__left`)}>
        {elementsRight.filter(el => !el.hidden).map((el, index) => (
          getElement(el, index)
        ))}
      </div>
    </div>
  );
};
